import styled from "styled-components";
import { colors, TextLink } from "@streeteasy/design-system";
import {
  Body,
  PrimaryMedium,
  SecondarySmall
} from "@streeteasy/design-system/typography";

import { smallScreen } from "../../../../shared/constants/screenSizes";
import { fairHousing } from "../../assets/index";

const { ACCENT_PRIMARY_LIGHTEST } = colors;

export const ModalContainer = styled.div`
  background: white;
  width: 679px;

  @media screen and (max-width: ${smallScreen}px) {
    height: 100%;
    width: 100%;
  }
`;

export const ModalTop = styled.div`
  background: ${ACCENT_PRIMARY_LIGHTEST};
  height: 144px;
  padding: 40px 188px 24px 55px;
  width: 679px;

  @media screen and (max-width: ${smallScreen}px) {
    height: auto;
    padding: 40px 85px 28px 24px;
    width: 100%;
  }
`;

export const ModalHeaderContainer = styled.div`
  background: ${ACCENT_PRIMARY_LIGHTEST};
  width: 500px;

  @media screen and (max-width: ${smallScreen}px) {
    width: 100%;
  }
`;
export const ModalHeader = styled(PrimaryMedium).attrs({})``;

export const BodyWrapper = styled.div`
  background: white;
  padding: 25px 56px 48px 56px;
  width: 679px;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 40px 24px 110px 24px;
    width: 100%;
  }
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  right: 24px;
  top: 24px;

  @media screen and (max-width: ${smallScreen}px) {
    top: 16px;
    right: 16px;
  }
`;

export const ModalParagraphTitle = styled(SecondarySmall).attrs({})`
  margin-bottom: 8px;
`;

export const ModalText = styled(Body).attrs({})`
  margin-bottom: 23px;
`;

export const FairHousingImage = styled.div`
  background: url(${fairHousing});
  background-position: right;
  background-size: cover;
  height: 98px;
  position: absolute;
  right: 0;
  top: 45px;
  width: 163px;

  @media screen and (max-width: ${smallScreen}px) {
    bottom: 0;
    top: auto;
  }
`;

export const MoreTipsLink = styled(TextLink).attrs({ underlined: false })`
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    padding: 0;
    line-height: inherit;
  }

  &:focus {
    padding: 0;
    text-decoration: none;
  }
`;
